import { Axis, Orientation, TickFormatter, TickRendererProps } from '@visx/axis';
import { NumberValue, ScaleLinear } from 'd3-scale';
import { NUM_Y_TICKS } from 'dashboard-engine/visualisations/getGridYValues';
import React from 'react';

interface YAxisProps {
    scale: ScaleLinear<number, number>;
    formatTick: TickFormatter<NumberValue>;
    label?: string;
}

export const YAxis: React.FC<YAxisProps> = ({ scale, formatTick, label }) => (
    <Axis
        orientation={Orientation.left}
        left={label ? 28 : 8}
        scale={scale}
        numTicks={NUM_Y_TICKS}
        hideAxisLine={true}
        hideTicks={true}
        tickFormat={formatTick}
        label={label}
        labelOffset={6}
        labelClassName='fill-textSecondary'
        labelProps={{
            fontSize: 12,
            fontFamily: 'Inter',
            textAnchor: 'middle'
        }}
        tickComponent={({ x, y, formattedValue }: TickRendererProps) => {
            return (
                <g transform={`translate(${x + 12},${y + 1})`}>
                    <text
                        alignmentBaseline='middle'
                        textAnchor='right'
                        className='fill-textSecondary'
                        style={{
                            opacity: 1,
                            stroke: 'var(--tileBackground)',
                            strokeWidth: '3px',
                            fontWeight: 500,
                            fontSize: '11px',
                            fontFamily: 'Inter',
                            paintOrder: 'stroke',
                            letterSpacing: '1px'
                        }}
                    >
                        {formattedValue}
                    </text>
                </g>
            );
        }}
    />
);
